import "./Popup.scss";
import React, { useEffect } from "react";
import { useDisabledScroll } from "../../hooks/useDisabledScroll";
import { PropsPopup } from "../../types";

const { handlerDisabledScroll } = useDisabledScroll;

const Popup: React.FC<PropsPopup> = ({ onClick, children, openPopup, allowPinchZoom = false }) => {
  useEffect(() => {
    handlerDisabledScroll(openPopup);

    return () => handlerDisabledScroll(false);
  }, [openPopup]);

  return (
    <div
      className={`popup ${openPopup ? "popup__opened" : ""} ${allowPinchZoom ? "popup__allow-pinch-zoom" : ""}`}
      aria-hidden={!openPopup}
      onClick={onClick}
    >
      {children}
    </div>
  );
};

export default Popup;
